export default __webpack_public_path__ + "src/assets/tasks/horerduordet/739_hmm_ordet_hørerduordet_alex.mp3";